import { useNavigate, useParams } from "react-router-dom";
import { MdKeyboardBackspace } from "react-icons/md";
import { useEffect, useState } from "react";
import { IoCartOutline, IoStar } from "react-icons/io5";
import { FaCheckCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import axios from "axios";
import capitalizeFirstLetter from "../../comman/capitalizeFirstLetter";
import { LuSquareEqual } from "react-icons/lu";
import { addToCart } from "../../../service/addToCart";
import { useDispatch} from "react-redux";
const Base_Url = process.env.REACT_APP_BASE_URL;
export default function ProductDetailPage()
{
  const navigate=useNavigate();
  const { id } = useParams();
  const storedUser = localStorage.getItem("customeruser");
  const dispatch=useDispatch();
  const [currentProduct, setCurrentProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [isZoomed, setIsZoomed] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [showAllReviews, setShowAllReviews] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [showAllAbout, setShowAllAbout] = useState(false);

  useEffect(() => {
  const fetchProductDetails = async () => {
    if (!id) return;

    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${Base_Url}/api/product/getProductDetails/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.success) {
        setCurrentProduct(res.data.data);
        setSelectedImage(res.data.data.images?.[0]?.image || "");
        setSelectedSize(res.data.data.sizes?.[0] || "");
        setSelectedColor(res.data.data.colors?.[0] || "");
    
      } else {
        toast.error(res.data.message || "Failed to fetch product details");
      }
    } catch (err) {
      console.error("❌ Fetch product error:", err);
      toast.error(err.response?.data?.message || "Failed to load product details");
    }
  };

  fetchProductDetails();
  }, [id]);

  if (!currentProduct) {
    return <div className="text-center text-red-500 mt-10">Product not found</div>;
  }
  
  const renderStarIcons = (rating) => (
    <div className="flex space-x-1">
      {Array.from({ length: 5 }, (_, index) => (
        <IoStar
          key={index}
          className={`w-4 h-3 md:w-5 md:h-5 ${index < rating ? "text-yellow-500" : "text-gray-300"}`}
        />
      ))}
    </div>
  );

  const renderStarIconsReviews = (rating) => (
    <div className="flex space-x-1">
      {Array.from({ length: 5 }, (_, index) => (
        <IoStar
          key={index}
          className={`w-4 h-3 md:w-4 xl:w-4 ${index < rating ? "text-pink-700" : "text-white"}`}
        />
      ))}
    </div>
  );

  const toggleReviews = () => {
    setShowAllReviews((prev) => !prev);
  };

  const reviewsToShow = showAllReviews
  ? currentProduct.reviews || []
  : (currentProduct.reviews || []).slice(0, 2);

  const details = [
    { label: "Category", value: currentProduct.category?.name },
    { label: "Model", value: currentProduct.model },  
    { label: "Color",value:selectedColor },
    { label: "Hard Disk Size", value:selectedSize },
    { label: "Screen size",value: currentProduct.screenSize },
    { label: "Ram memory installed size", value: currentProduct.ram },
    { label: "CPU model", value:currentProduct.cpuModel },
    { label: "Operating System", value: currentProduct.operatingSystem },
    { label: "Special Feature", value: currentProduct.specialFeature },
    { label: "Graphics card description", value: currentProduct.graphicsCard },
  ];

  const visibleDetails = showAll ? details : details.slice(0, 4);

  const visibleItems = showAllAbout
    ? currentProduct.moreDetails || []
    : (currentProduct.moreDetails || []).slice(0, 3);
    
  const handleMouseMove = (e) => {
  const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
  const x = ((e.pageX - left) / width) * 100;
  const y = ((e.pageY - top) / height) * 100;
  setPosition({ x, y });
};

  const toggleCart=(productId)=>{
    if (!storedUser) {
      toast.warning("Please login to manage wishlist");
      setTimeout(() => navigate("/login"), 1000);
      return;
    }
    dispatch(addToCart(productId,1,selectedColor,selectedSize));
  };


  return(
<section className="px-5 py-5 bg-gray-100">
  <div className="flex flex-row justify-between items-center mb-5">
      <div className="flex flex-row space-x-2 items-center" onClick={()=>navigate(-1)}>
        <MdKeyboardBackspace className="text-base md:text-lg xl:text-xl" />
        <h2 className="text-base md:text-lg xl:text-xl font-bold">Product detail</h2>
      </div>
  </div>
        
    <div className="flex flex-col md:flex-row bg-white py-6 px-2 rounded shadow-lg h-auto md:h-[600px]">
       
      <div className="w-full md:w-1/2 flex-shrink-0 flex flex-col items-center">
        <div
          className="relative"
          onMouseEnter={() => setIsZoomed(true)}
          onMouseLeave={() => setIsZoomed(false)}
          onMouseMove={handleMouseMove}
        >
          <img
            src={selectedImage}
            alt={currentProduct.productName}
            className="h-56 md:h-64 xl:h-72 w-72 md:w-72 xl:w-96 object-contain border border-gray-500 rounded"
          />

          {isZoomed && (
          <div
            className="absolute w-16 h-16 border-2 border-pink-600 bg-white bg-opacity-30 pointer-events-none"
            style={{
            top: `${position.y}%`,
            left: `${position.x}%`,
            transform: "translate(-50%, -50%)",
            }}
          />
          )}
        </div>
        <div className="flex gap-2 mt-4">
            {(currentProduct.images).map((img, i) => (
                <img
                    key={i}
                    src={img.image}
                    onClick={() => setSelectedImage(img.image)}
                    className={`w-14 h-14 md:h-16 md:w-16 xl:h-20 xl:w-20 object-contain border border-gray-500 rounded cursor-pointer ${
                    selectedImage === img.image? "ring-2 ring-pink-600" : ""
                    }`}
                    alt={`thumb-${i}`}
                />
            ))}
        </div>

            <div  className={`mt-6 flex w-full px-2 md:px-10 xl:px-32 justify-between gap-4 text-xs md:text-sm xl:text-base rounded-md py-2 transition-opacity`}>
            <button
              className={`hover:bg-[#b34040] bg-[#E96364] text-white px-5 py-2 rounded flex flex-row space-x-2 items-center 
              ${(currentProduct.stockStatus==="noStockData" || currentProduct.stockStatus==="outOfStock") ? "opacity-50 cursor-not-allowed" : "hover:scale-110"}`}
              disabled={(currentProduct.stockStatus==="noStockData" || currentProduct.stockStatus==="outOfStock")}
              onClick={() => toggleCart(currentProduct.id)}
            >
                <IoCartOutline />
              Add to Cart
            </button>
            <button
              className={`hover:bg-[#b34040] bg-[#E96364] text-white px-5 py-2 rounded flex flex-row space-x-2 items-center ${
              (currentProduct.stockStatus==="noStockData" || currentProduct.stockStatus==="outOfStock")? "opacity-50 cursor-not-allowed" : "hover:scale-110"
              }`}
              disabled={ (currentProduct.stockStatus==="noStockData"|| currentProduct.stockStatus==="outOfStock" )}
              onClick={() => {
                  navigate("/cartpage"); 
                }
              }
            >
              <LuSquareEqual />
              Buy Now
            </button>

            </div>
       </div>

        {isZoomed && (
          <div className="block absolute top-[360px] md:top-16 right-2 xl:right-2 w-[280px] md:w-[360px] lg:w-[600px] xl:w-[750px] h-[300px] md:h-[470px] lg:h-[650px] xl:h-[560px] border bg-opacity-100 border-gray-300 rounded overflow-hidden bg-white shadow-lg z-50 ">
            <img
              src={selectedImage}
              alt="Zoom Preview"
              className="w-full h-full object-cover"
              style={{
              transform: `translate(-${position.x}%, -${position.y}%) scale(2)`, // zoom level
              transformOrigin: "top left",
              }}
            />
          </div>
        )}

      <div className="w-full lg:w-1/2 mt-6 md:mt-0 md:pl-9 pr-5 space-y-5 h-full overflow-y-auto">
        <div className="flex flex-col space-y-2">
          
          <h1 className="text-base md:text-xl xl:text-2xl font-semibold">{capitalizeFirstLetter(currentProduct.productName)} | {capitalizeFirstLetter(currentProduct.model)} | {capitalizeFirstLetter(currentProduct.category?.name)} | {capitalizeFirstLetter(currentProduct.colors[0])} | {capitalizeFirstLetter(currentProduct.cpuModel)} | {capitalizeFirstLetter(currentProduct.screenSize)} | {capitalizeFirstLetter(currentProduct.operatingSystem)}</h1>

          <p className="text-gray-600 text-xs md:text-sm xl:text-base">
            {capitalizeFirstLetter(currentProduct.description)}
          </p>

          <div className="flex flex-row space-x-5 items-center">
                <div className=" flex justify-center ">{renderStarIcons(currentProduct.averageRating)}</div>
                <p
                    className={`font-medium text-sm xl:text-base px-2 py-1 ${
                    currentProduct.stockStatus === "inStock" 
                    ? "text-green-600 border-2 rounded-md border-dashed border-green-700" 
                    : "text-red-600 border-2 rounded-md border-dashed border-red-700"
                    }`}
                >
                    {currentProduct.stockStatus === "inStock" ? "Instock" : " Out Of Stock"}
                </p>
          </div>

          <div className="flex flex-row items-center space-x-3 text-xs md:text-sm xl:text-base font-medium border border-gray-500 rounded p-2 xl:p-4">
            <div className="flex flex-col space-y-1 w-2/3">
                <p className=" text-gray-800">₹{Math.round(currentProduct.discountedPrice)}<span> ( Inclusive of all Taxes )</span></p>
                <p className="text-gray-500">Original Price : <span className="line-through text-gray-500">₹{Math.round(currentProduct.originalPrice)}</span> </p>
            </div>   
            <div className="w-1/3">
                <p className="text-white bg-[#E96364] px-2 py-1 rounded text-center">Save ₹{currentProduct.originalPrice - currentProduct.discountedPrice}</p>
            </div>                          
          </div>
        </div>

          <div className="flex flex-row flex-wrap space-y-2 space-x-2 md:space-x-3 xl:space-x-5 ">
           {(currentProduct.specifications || []).map((item, i) => {
                return (
                <div
                    key={i}
                    className="flex flex-col items-center gap-2 bg-pink-200 px-4 py-2 rounded-md text-xs md:text-sm xl:text-base text-black"
                >
                    <span className="text-center">{capitalizeFirstLetter(item)}</span>
                </div>
                );
            })}
          </div>

          <div className="">
            <p className="text-sm md:text-base xl:text-lg font-medium mb-2">Configuration</p>
            <div className="grid grid-cols-2 lg:grid-cols-3 border-2 shadow-md border-[#A63F40] rounded-lg p-2">
                {(currentProduct.configurations || []).map((item, i) => (
                    <div key={i} className="flex items-center gap-2 text-gray-800 text-xs md:text-sm xl:text-base">
                        <FaCheckCircle className="text-green-600" />
                        <span>{capitalizeFirstLetter(item)}</span>
                    </div>
                ))}
            </div>
          </div>

          {currentProduct.colors?.length > 0 && (
            <div className="mt-4 border-t border-gray-700 pt-3">
              <p className="font-medium mb-1 text-sm md:text-base xl:text-base">Select Color:</p>
              <div className="flex gap-2 overflow-x-auto">
                {currentProduct.colors.map((color) => (
                  <div
                    key={color}
                    onClick={() => setSelectedColor(color)}
                    className={`px-3 py-1 border text-xs md:text-sm xl:text-base rounded cursor-pointer ${
                      selectedColor === color ? "border border-pink-600 text-black" : ""
                    }`}
                  >
                    {capitalizeFirstLetter(color)}
                  </div>
                ))}
              </div>
            </div>
          )}

          {currentProduct.sizes?.length > 0 && (
            <div className="mt-4">
              <p className="font-medium mb-1 text-sm md:text-base xl:text-base">Select Size:</p>
              <div className="flex gap-2">
                {currentProduct.sizes.map((size) => (
                  <button
                    key={size}
                    onClick={() => setSelectedSize(size)}
                    className={`px-3 py-1 border rounded text-xs md:text-sm xl:text-base ${
                      selectedSize === size ? " border border-pink-600 text-black" : ""
                    }`}
                  >
                    {capitalizeFirstLetter(size)}
                  </button>
                ))}
              </div>
            </div>
          )}
          
          <div className="border-b border-gray-700 pb-3 px-2">
             <div className="text-xs md:text-sm xl:text-base grid grid-cols-1 gap-y-2 lg:gap-y-1">
              {visibleDetails.map((item, index) => (
                <div key={index} className="grid grid-cols-2">
                  <p className="text-black font-medium">{capitalizeFirstLetter(item.label)} :</p>
                  <p className="text-gray-900">{capitalizeFirstLetter(item.value)}</p>
                </div>
              ))}
            </div>
            {details.length > 4 && (
            <button
              onClick={() => setShowAll(!showAll)}
              className="mt-3 text-blue-600 text-sm font-medium hover:underline"
            >
                {showAll ? "Show Less" : "Show More"}
            </button>
            )}
          </div>

          <div className="space-y-2">
            <p className="text-sm md:text-base xl:text-lg font-medium">About this product</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-1 text-xs md:text-sm xl:text-base">
              {visibleItems.map((item, index) => (
                <li key={index}>
                  <span className="font-medium">{capitalizeFirstLetter(item.name)}:</span> {capitalizeFirstLetter(item.value)}
                </li>
              ))}
            </ul>
            {currentProduct.moreDetails.length > 3 && (
              <button
                onClick={() => setShowAllAbout(!showAllAbout)}
                className="text-blue-600 hover:underline mt-2 text-sm font-medium"
              >
                {showAllAbout ? "Show Less" : "Show More"}
              </button>
            )}
          </div>
          
          <div className="">
            <p className="text-sm md:text-base xl:text-lg font-medium mb-2">Reviews</p>
            {currentProduct.reviews.length === 0 ?(
                <p className="">No Reviews added for this product</p>
            ) : (
            <div className="grid grid-cols-2 gap-3 rounded-lg">
              {reviewsToShow.map((item, i) => (
              <div
                key={i}
                className="flex flex-col p-2 gap-2 text-gray-800 text-xs md:text-sm xl:text-base bg-pink-100 rounded-lg"
              >
                <div className="flex flex-row space-x-1 items-center">
                  {/* <img src={item.img} className="w-5 h-5" /> */}
                  <p className="font-medium">{item.user.name}</p>
                </div>
                <p>{item.review}</p>
                <div className="flex justify-start">{renderStarIconsReviews(item.rating)}</div>
              </div>
              ))}
            </div>
            )
           }
            {currentProduct.reviews.length > 2 && (
            <button
              onClick={toggleReviews}
              className="mt-3 text-xs md:text-sm xl:text-base text-[#A63F40] underline"
            >
              {showAllReviews ? "See Less" : "See More"}
            </button>
            )}
          
          </div>    
          
      </div>
    </div>
</section>
    );
}










